export class QuotingContextData {
    constructor() {
        this.EmployeeList = Array<EmployeeData>();
        this.NetworkIds = '';
    }
    QuoteClassificationType: number;
    EmployeeList: EmployeeData[];
    NonCOBRAEmpList: any[];
    EffectiveDate: string;
    SelectedCarrier: SelectedCarrier;
    EmployerZipCode: string;
    EmployerCountyCode: string;
    SicCode: string;
    State: string;
    CoverageType: number;
    Segment: number;
    EmployerStateLawArea: string;
    GetMedicalEmpCount: number;
    PlansData: any;
    Plans: any;
    IsWrappedCarrierRequested: boolean;
    IsWrappedCarrier: boolean;
    NetworkErrorsList: any;
    AvailableSmallGroupCarriers: any;
    EligibleCarriers: any;
    ExcludedCarriers: any;
    AvailableActiveCarriers: any;
    UserRole: any;
    Errors: any;
    IsADP: string;
    QuoteType: number;
    NetworkIds:string;
    ERCountyCode:string;
    StateCode:string;
    ERStateId:number;
    CarrierId:number;
    CarrierName:string;
    ERZipCode:string;
    CoverageTypeId:number;
}

export class EmployeeData {
    constructor() {
        this.Dependents = Array<EmployeeData>();
    }
    Id: number;
    Age: number;
    DateOfBirth: string;
    CountyCode: string;
    FirstName: string;
    LastName: string;
    IsTobaccoUser: boolean;
    Dependents: EmployeeData[]
    EmployeeType: string;
    ZipCode: string;
    Gender: number;
    State: string;
    IsLifeOnly: boolean;
    IsCOBRA: boolean;
}

export class SelectedCarrier {

    carrierId: number;
    carrierName: string;
    networkId:string;
}
